import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, fmt } from '../api';

export default function Products() {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => {
    api.products().then(setRows);
  }, []);

  return (
    <>
      <h2 className="page-title">Product Intelligence</h2>
      <p className="page-sub">Ranked by revenue + ad-fit. Launch in one click from any product.</p>
      <div className="product-grid">
        {rows.map((p) => (
          <div key={p.id} className="product-card">
            <div className="img" style={{ backgroundImage: `url(${p.image_url})` }} />
            <div className="body">
              <div className="title">{p.title}</div>
              <div className="meta">{fmt.money(p.price_cents)} · {fmt.num(p.units_sold_30d)} sold</div>
              <div className="fit-meter">
                <span style={{ width: `${p.ad_fit_score}%` }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 11, color: 'var(--text-mute)' }}>Ad-fit {p.ad_fit_score}/100</span>
                {p.is_bestseller ? (
                  <span className="badge badge-active">Bestseller</span>
                ) : null}
              </div>
              <div style={{ marginTop: 10, fontSize: 13, fontWeight: 600 }}>
                {fmt.moneyShort(p.revenue_30d_cents)} <span style={{ color: 'var(--text-sub)', fontSize: 11, fontWeight: 400 }}>30d revenue</span>
              </div>
              <Link to={`/campaigns/new`} className="btn btn-primary btn-small" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }}>
                Launch campaign
              </Link>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
